import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-phone',
  templateUrl: './phone.component.svg',
})
export class PhoneComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
